"use client";

import { useEffect } from "react";
import { toast } from "sonner";

const STATUS_MESSAGES: Record<
  string,
  { level: "success" | "info" | "error"; message: string }
> = {
  success: {
    level: "success",
    message: "Lifetime access unlocked. Enjoy the full features!",
  },
  cancelled: {
    level: "info",
    message: "Checkout was cancelled. No charge issued.",
  },
  "checkout-success-active": {
    level: "success",
    message: "Lifetime access unlocked. Enjoy the full features!",
  },
  "checkout-success-pending": {
    level: "info",
    message:
      "Lifetime isn't unlocked yet. Sign in with the payment email to activate it.",
  },
  "checkout-cancelled": {
    level: "info",
    message: "Checkout was cancelled. No charge issued.",
  },
  "featured-success": {
    level: "success",
    message:
      "I've been notified and will review your request asap. If everything looks good, I'll make it live.",
  },
  "featured-cancelled": {
    level: "info",
    message: "Featured Spot checkout was cancelled. No charge issued.",
  },
  "checkout-already-active": {
    level: "info",
    message: "Lifetime access is already active. You don't need to buy again.",
  },
  "checkout-subscription-active": {
    level: "info",
    message:
      "Monthly subscription is already active. No additional purchase needed.",
  },
  "checkout-subscription-started": {
    level: "success",
    message: "Monthly subscription activated. Enjoy the full features!",
  },
};

interface CheckoutStatusListenerProps {
  status?: string | null;
  silent?: boolean;
}

export function CheckoutStatusListener({
  status,
  silent = false,
}: CheckoutStatusListenerProps) {
  useEffect(() => {
    if (!status) return;

    const payload = STATUS_MESSAGES[status];
    if (!silent && payload) {
      window.requestAnimationFrame(() => {
        if (payload.level === "success") {
          toast.success(payload.message);
        } else if (payload.level === "info") {
          toast.info(payload.message);
        } else {
          toast.error(payload.message);
        }
      });
    }

    try {
      const url = new URL(window.location.href);
      url.searchParams.delete("checkout");
      window.history.replaceState(
        null,
        "",
        url.pathname + url.search + url.hash
      );
    } catch (error) {
      console.warn("Failed to strip checkout query param", error);
    }
  }, [silent, status]);

  return null;
}
